import React, { FC } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import ModalBoxCore from "../../../core-components/modal-box/ModalBoxCore";
import ModalHeader from "../../../core-components/modal-box/modal-header/ModalHeader";
import ModalBody from "../../../core-components/modal-box/modal-body/ModalBody";
import CoreButtons from "../../../core-components/button/CoreButtons";
import {
	BUTTON_COLOR,
	BUTTON_VARIANT,
} from "../../../../types/coreButtonTypes";
import { iShopifyDeclineModalProps } from "../../../../types/modalBoxType";

import "./shopifyDeclineModal.css";

const ShopifyDeclineModal: FC<iShopifyDeclineModalProps> = ({
	open,
	onClose,
	modalHeaderText,
	shopifyDeclineModalBodyText,
	declineOnClick,
	backOnClick,
}) => {
	const theme = useTheme();
	return (
		<>
			<ModalBoxCore
				open={open}
				onClose={onClose}
				className="shopify_decline_modal"
			>
				<ModalHeader
					modalHeaderText={modalHeaderText}
					closeModal={onClose}
				/>
				<ModalBody>
					<Typography
						variant="body1"
						sx={{
							textAlign: "center",
							marginInline: "auto",
							color: "#22031F",
							maxWidth: "374px"
						}}>
						{shopifyDeclineModalBodyText}
					</Typography>
					<Box
						className="btn_group"
						sx={{
							display: "flex",
							flexWrap: "wrap",
							alignItems: "center",
							justifyContent: "center",
							gap: "16px 20px",
							paddingBlockStart: "34px",
							paddingBlockEnd: "14px",

							[theme.breakpoints.up(439.98)]: {
								flexWrap: "unset",
							}
						}}>
						<CoreButtons
							buttonText="Decline Request"
							variant={BUTTON_VARIANT.OUTLINED}
							color={BUTTON_COLOR.ERROR}
							fullWidth={true}
							coreBtnPill={true}
							onclick={declineOnClick}
						/>
						<CoreButtons
							buttonText="Back"
							variant={BUTTON_VARIANT.CONTAINED}
							color={BUTTON_COLOR.PRIMARY}
							fullWidth={true}
							coreBtnPill={true}
							onclick={backOnClick}
						/>
					</Box>
				</ModalBody>
			</ModalBoxCore>
		</>
	);
};
export default ShopifyDeclineModal;
